export const getFirebaseErrorMessage = (code) =>
{
  switch (code)
  {
    // Authentication
    case "auth/email-already-in-use":
      return "An account with this email address already exists.";

    case "auth/invalid-email":
      return "Please enter a valid email address.";

    case "auth/user-disabled":
      return "This account has been disabled.";

    case "auth/user-not-found":
      return "No account was found with this email address.";

    case "auth/wrong-password":
    case "auth/invalid-credential":
      return "Incorrect email or password.";

    case "auth/weak-password":
      return "Your password is too weak. Please choose a stronger password.";

    case "auth/missing-password":
      return "Please enter your password.";

    case "auth/missing-email":
      return "Please enter your email address.";

    // Verification
    case "auth/email-not-verified":
      return "Please verify your email address before continuing.";

    // Account creation
    case "auth/operation-not-allowed":
      return "Email/password sign-up is currently unavailable.";

    // Network
    case "auth/network-request-failed":
      return "Network error. Please check your internet connection and try again.";

    case "auth/timeout":
      return "The request timed out. Please try again.";

    // Rate limiting
    case "auth/too-many-requests":
      return "Too many attempts. Please wait a few minutes before trying again.";

    // Token / Session
    case "auth/user-token-expired":
      return "Your session has expired. Please sign in again.";

    case "auth/requires-recent-login":
      return "Please sign in again before performing this action.";

    // Popup providers (future-proofing)
    case "auth/popup-closed-by-user":
      return "The sign-in window was closed before completing the sign-in.";

    case "auth/popup-blocked":
      return "Your browser blocked the sign-in popup. Please allow popups and try again.";

    case "auth/cancelled-popup-request":
      return "Another sign-in request is already in progress.";

    // Generic
    default:
      return "Something went wrong. Please try again later.";
  }
};